export default "dist/images/components-columns-width-control-2-3-uneven.a5425ee.png";